"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartStateType = void 0;
var ChartStateType;
(function (ChartStateType) {
    ChartStateType[ChartStateType["Range"] = 0] = "Range";
    ChartStateType[ChartStateType["Line"] = 1] = "Line";
    ChartStateType[ChartStateType["LineBar"] = 2] = "LineBar";
    ChartStateType[ChartStateType["RangeBar"] = 3] = "RangeBar";
    ChartStateType[ChartStateType["Bar"] = 4] = "Bar";
    ChartStateType[ChartStateType["StackBar"] = 5] = "StackBar";
    ChartStateType[ChartStateType["MultiLine"] = 6] = "MultiLine";
})(ChartStateType = exports.ChartStateType || (exports.ChartStateType = {}));
